module.exports = __webpack_public_path__ + "img/prudetabanner.747a89df.jpg";